
import * as types from './userActionTypes.js';

export const setUserToken = (userToken) => ({ type: types.SET_USERTOKEN, userToken: userToken });
export const setUserInfo = (userInfo) => ({type: types.SET_USERINFO, userInfo: userInfo});
export const setPacker = (packer) => ({type: types.SET_PACKER, packer: packer})
export const setLogoutTimeout = (logoutTimeout) => ({type: types.SET_LOGOUTTIMEOUT, logoutTimeout: logoutTimeout});